<div class="dialog-wrapper" dir="rtl">
  <!-- ── Header ─────────────────────────────────── -->
  <div class="dialog-header">
    <h2 class="dialog-title">إضافة مُرفق</h2>
    <button class="close-btn" (click)="onClose()">&#x2715;</button>
  </div>

  <!-- ── Body ───────────────────────────────────── -->
  <div class="dialog-body">
    <!-- Preview Image -->
    <div class="preview-container">
      <img
        *ngIf="!photoPreview"
        src="../../../assets/img/frontid.png"
        alt="مرفق"
        class="preview-img"
      />
      <img
        *ngIf="photoPreview"
        [src]="photoPreview"
        alt="مرفق"
        class="preview-img uploaded"
      />
    </div>

    <!-- المرفق label + file input -->
    <div class="form-group">
      <label class="form-label">المرفق</label>
      <div class="file-input-row">
        <input
          #fileInput
          type="file"
          accept="image/*,.pdf,.doc,.docx"
          multiple
          (change)="onFileChange($event)"
          hidden
        />
        <span class="no-file-label">{{
          selectedFileName || "No file chosen"
        }}</span>
        <button class="btn btn-choose" (click)="fileInput.click()">
          Choose Files
        </button>
      </div>
    </div>

    <!-- Camera Buttons -->
    <button class="btn btn-camera" (click)="openCamera()">
      تجهيز الكاميرا
    </button>
    <button class="btn btn-capture" (click)="capturePhoto()">إلتقط صوره</button>

    <!-- التعليق على الملف -->
    <div class="form-group">
      <label class="form-label">التعليق على الملف</label>
      <textarea
        class="form-textarea"
        [(ngModel)]="comment"
        name="comment"
        rows="2"
        placeholder=""
      ></textarea>
    </div>
  </div>

  <!-- ── Footer ─────────────────────────────────── -->
  <div class="dialog-footer">
    <button class="btn btn-cancel" (click)="onClose()">إلغاء</button>
    <button class="btn btn-submit" (click)="onSubmit()">تسجيل</button>
  </div>
</div>
